import { Schema } from "@comparaonline/marketplace-schema";
import MUILink from "@material-ui/core/Link";
import React from "react";

import { Card } from "./Card";
import { CardContainer } from "./CardContainer";
import { getTipUrl } from "../../../../../../models/tip";
import { useAppContext } from "../../../../../../lib/appContext";

interface TipCardProps {
  hasDrawerOpen: boolean;
  educationTip: Schema.Education;
  onClick: () => void;
  onClose: () => void;
  imageUrl: string;
}

export const TipCard: React.FC<TipCardProps> = ({ educationTip, imageUrl }) => {
  const { businessUnitSlug, countryCode } = useAppContext();
  const tipUrl = getTipUrl(countryCode, businessUnitSlug, educationTip);
  return (
    <CardContainer>
      <MUILink variant="body2" color="primary" underline="none" href={tipUrl}>
        <Card title={educationTip.question} imageUrl={imageUrl} />
      </MUILink>
    </CardContainer>
  );
};
